import SWENext from '../assets/outreach_imgs/swe_next.jpg';
import EDGE from '../assets/outreach_imgs/edge.jpeg';
import Envision from '../assets/outreach_imgs/envision.jpg';

const OutreachEvents = [
  {
    name: 'Envision',
    image: Envision,
    description: 'Envision is an annual conference for high school girls to participate in hands-on activities, attend panels from students and professors and lab tours, and hear from industry speakers. Envision is taking place Saturday, February 8, 2025. ',
    link: 'https://ucsdenvision.wixsite.com/envision',
  },
  {
    name: 'EDGE',
    image: EDGE,
    description: 'EDGE is a free, year-long program aimed to encourage more girls into STEM-related careers in the future in collaboration with Women in Computing at UC San Diego. Participants engage with undergraduate mentors and attend engineering and professional development workshops.',
    link: 'https://edgeucsd.wixsite.com/edge',
  },
  {
    name: 'SWENext',
    image: SWENext,
    description: 'SWENext is a K-12 outreach program that allows local students to connect with our SWE engineering community. SWENexters have access to programs, mentors, and resources to help them succeed in a STEM career.',
    link: 'https://swe.org/outreach/swenext-clubs/#:~:text=SWENext%20is%20a%20way%20for,in%20engineering%20and%20technology%20careers.',
  },
];

export default OutreachEvents;
